import "./App.css";
import Home from "./pages/Home";
import { Route, BrowserRouter as Router, Switch, Link } from "react-router-dom";
import About from "./pages/About";
import React, { useState } from "react";
import Auth from "./pages/Auth";
import Signup from "./pages/Signup";
import Create from "./pages/Create";

function App() {
  const [token, setToken] = useState();
  const [username, setUser] = useState();

  return (
    <Router>
      <div className="wrapper">
        <nav>
          <ul>
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/about">About</Link>
            </li>
            {!token && (
              <div>
                <li>
                  <Link to="/auth">Login</Link>
                </li>
                <li>
                  <Link to="/signup">Signup</Link>
                </li>
              </div>
            )}
            {token && (
              <div>
              <li>
                <Link to="/create">Create</Link>
              </li>
              <li>
                User : {username}
                <button
                  onClick={() => {
                    setToken("");
                  }}
                >
                  Logout
                </button>
              </li>
              </div>
            )}
          </ul>
        </nav>
      </div>
      <Switch>
        <Route
          path="/" exact
          component={() => <Home token={token} />}
        />
        <Route path="/about" component={About} />
        <Route
          path="/auth"
          component={() => <Auth setToken={setToken} setUser={setUser} />}
        />
        <Route
          path="/signup"
          component={() => <Signup setToken={setToken} />}
        />
        <Route
          path="/create"
          component={() => <Create setToken={setToken} token={token} />}
        />
      </Switch>
    </Router>
  );
}

export default App;
